/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const StarCircled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Star circled"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M11.458 7.348a.625.625 0 0 1 1.12 0L13.71 9.64a.63.63 0 0 0 .47.342l2.53.367a.625.625 0 0 1 .346 1.066l-1.83 1.784a.63.63 0 0 0-.18.553l.432 2.519c.088.51-.448.9-.907.659l-2.262-1.19a.63.63 0 0 0-.582 0l-2.261 1.19a.625.625 0 0 1-.907-.659l.432-2.519a.63.63 0 0 0-.18-.553l-1.83-1.784a.625.625 0 0 1 .346-1.066l2.53-.367a.63.63 0 0 0 .47-.342z"
      />
      <path
        fill="#0E0E0E"
        d="M20.333 12A8.333 8.333 0 1 0 12 20.333V22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10v-1.667A8.333 8.333 0 0 0 20.333 12"
      />
    </g>
  </svg>
);

export const StarCircledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-circled-icon'}
      icon={StarCircled}
      {...props}
      size={size}
    />
  );
};
